export class ValidationError extends Error {
  constructor(status, response) {
    super(`Validation Error. Status: ${status}`);
    this.status = status;
    this.response = response;
  }

}